import { useLocation } from "react-router-dom";

export function useAbsoluteRoot() {
    //const { mirs_competition } = useParams() 
    const location = useLocation();
    let urlRoot = ""
    if (typeof window === "undefined" || typeof document === "undefined") {
        urlRoot = "http://localhost:8080/"
    } else {

        const pathnameSplited = location.pathname?.replace(/(\/)+/g, "$1")?.split('/')
        //const pathname = document?.location?.pathname?.replace(/(\/)+/g, "$1")
        //const pathnameSplited = pathname?.split('/');
        //const hasCompetitionInTheUrl = Array.isArray(pathnameSplited) && pathnameSplited.length > 1;
        //urlRoot = mirs_competition ? `/${mirs_competition}/` : hasCompetitionInTheUrl ? `/${pathnameSplited[1]}/` : '/';
        urlRoot = `/${process.env.REACT_APP_DEFAULT_COMPETITION}/` //TODO Fix this!!! 
        //urlRoot = "http://localhost:3002/" //Only for local compiler builder 
    }
    return { urlRoot }
}


export function getAbsoluteRoot() {
    const pathname = document?.location?.pathname?.replace(/(\/)+/g, "$1")
    //const pathnameSplited = pathname?.split('/');
    //const hasCompetitionInTheUrl = Array.isArray(pathnameSplited) && pathnameSplited.length > 1;
    //const urlRoot = hasCompetitionInTheUrl ? `/${pathnameSplited[1]}/` : '/';
    //console.log("getAbsoluteRoot", urlRoot)
    const urlRoot = `/${process.env.REACT_APP_DEFAULT_COMPETITION}/` //TODO Fix this!!! 
    return urlRoot
}

/**
 * 
 * @returns Get mirs_competition and mirs_langauge from path before apply ApplicationRouter
 */
export function useGetRawParamsFromPath() {
    const location = useLocation();
    let pathVars = location.pathname.split('/')
    return { mirs_language: pathVars[1], mirs_competition: pathVars[2], mirs_path: pathVars[3] }
}